import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Avatar
} from '@mui/material';
import {
  Settings as SettingsIcon,
  Logout as LogoutIcon
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout, loginWithGoogle } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);

  React.useEffect(() => {
    console.log('Navbar user data:', user);
  }, [user]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleMenuClose();
    navigate('/');
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const isActive = (path) => location.pathname === path;
  const isLoggedIn = Boolean(user);

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1, flexGrow: 1, cursor: 'pointer' }}
          onClick={() => navigate(isLoggedIn ? '/dashboard' : '/')}
        >
          <img
            src="/images/datahive_logo_no_text.png"
            alt="DataHive logo"
            style={{ height: 28, width: 'auto' }}
          />
          <Typography
            variant="h6"
            component="div"
          >
            DataHive
          </Typography>
        </Box>

        {isLoggedIn ? (
          <>
            <Box sx={{ display: 'flex', gap: 1, mr: 2 }}>
              <Button
                color="inherit"
                onClick={() => handleNavigation('/dashboard')}
                sx={{
                  backgroundColor: isActive('/dashboard') ? 'rgba(255,255,255,0.1)' : 'transparent'
                }}
              >
                Dashboard
              </Button>
              <Button
                color="inherit"
                onClick={() => handleNavigation('/analytics')}
                sx={{
                  backgroundColor: isActive('/analytics') ? 'rgba(255,255,255,0.1)' : 'transparent'
                }}
              >
                Analytics
              </Button>
              <Button
                color="inherit"
                onClick={() => handleNavigation('/settings')}
                sx={{
                  backgroundColor: isActive('/settings') ? 'rgba(255,255,255,0.1)' : 'transparent'
                }}
              >
                Settings
              </Button>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2" sx={{ display: { xs: 'none', sm: 'block' } }}>
                {user?.display_name || 'User'}
              </Typography>
              <IconButton
                size="large"
                onClick={handleMenuOpen}
                color="inherit"
              >
                {user?.avatar_url ? (
                  <Avatar src={user.avatar_url} sx={{ width: 32, height: 32 }} />
                ) : null}
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <MenuItem onClick={() => { handleNavigation('/settings'); handleMenuClose(); }}>
                  <SettingsIcon sx={{ mr: 1 }} />
                  Settings
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  <LogoutIcon sx={{ mr: 1 }} />
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          </>
        ) : (
          <Button
            color="inherit"
            onClick={loginWithGoogle}
            sx={{
              border: '1px solid rgba(255,255,255,0.5)'
            }}
          >
            Sign in with Google
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
